// Copyright 2025, Colin McKee
// SPDX-License-Identifier: Apache-2.0
package io.github.fletchmckee.liquid.samples.app.nodes

import androidx.compose.runtime.Stable
import androidx.compose.ui.Modifier

@Stable
actual fun Modifier.testTagsAsResourceId(enable: Boolean): Modifier = this
